module.exports = __webpack_public_path__ + "media/components/country-flag/static/nr-4981ebb263658279ac81d10741801622.svg";